/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "./request";
const mockUrl_0_0_0_0 = "http://yapi.yishou.com/mock/128";
const devUrl_0_0_0_0 = "http://erp38.yishou.com/";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 [商品抵扣列表↗](http://yapi.yishou.com/project/128/interface/api/29938) 的 **请求配置**
 *
 * @分类 [采购商品↗](http://yapi.yishou.com/project/128/interface/api/cat_2286)
 * @请求头 `POST /erp/Deduction/goodsDedList`
 * @更新时间 `2021-10-08 15:45:07`
 */
const goodsDedListRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/Deduction/goodsDedList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: "object",
    required: ["page"],
    properties: {
      time: {
        type: "string",
        description: "待抵扣生产时间数组{time[0],time[1]}",
      },
      city: { type: "string", description: "城市数组 0工作 1杭州 2深圳 3青岛" },
      page: { type: "string", description: "分页页数" },
      use_ded_time: {
        type: "string",
        description: "使用抵扣时间数组{time[0],time[1]}",
      },
      refunder_id: { type: "string", description: "售后退供人" },
      dgid: { type: "string", description: "次品组" },
      dpc_id: { type: "string", description: "退换货负责人" },
      order_owner: { type: "string", description: "订单负责人" },
      referer: { type: "string", description: "抵扣商品来源" },
      status: { type: "string", description: "抵扣状态" },
      pay_type: { type: "string", description: "交易类型" },
      pgid: { type: "string", description: "" },
      pg_id: { type: "string", description: "买手组" },
      woid: { type: "string", description: "采购单号" },
      supply_name: { type: "string", description: "供应商名字" },
      brand_name: { type: "string", description: "商品品牌" },
      market_name: { type: "string", description: "市场名字" },
      goods_name: { type: "string", description: "商品名字" },
      goods_no: { type: "string", description: "商品货号" },
      order_time: { type: "string", description: "订单生产时间数组" },
      is_pc: { type: "string", description: "" },
      wdid: { type: "string", description: "可抵扣商品id" },
    },
  },
  responseDataJsonSchema: {
    type: "object",
    properties: {
      total: {
        type: "object",
        properties: {
          wait_ded_num: { type: "number", description: "待抵扣数量" },
          part_ded_num: { type: "number", description: "部分抵扣数量" },
          done_ded_num: { type: "number", description: "已经抵扣数量" },
          wait_ded_amount: { type: "string", description: "待抵扣金额" },
          part_ded_amount: { type: "number", description: "已经抵扣金额" },
        },
      },
      list: {
        type: "array",
        items: {
          type: "object",
          properties: {
            wdid: { type: "number", description: "抵扣商品id" },
            goods_img: { type: "string", description: "商品图片" },
            goods_name: { type: "string", description: "商品名称" },
            goods_no: { type: "number", description: "商品编号" },
            co_val: { type: "string", description: "颜色" },
            si_val: { type: "string", description: "尺寸" },
            num: { type: "number", description: "数量" },
            market_name: { type: "string", description: "市场名称" },
            supply_name: { type: "string", description: "供应商名称" },
            supply_city: { type: "string", description: "供应商城市" },
            brand_name: { type: "string", description: "品牌名称" },
            pg_name: { type: "string", description: "买手组名字" },
            pgname: { type: "string", description: "采购组名字" },
            woid: { type: "number", description: "采购单编号" },
            ded_price: { type: "string", description: "抵扣价格" },
            price: { type: "string", description: "采购价格" },
            balance: { type: "string", description: "待抵扣价格" },
            wcg_ded_status: { type: "string", description: "抵扣状态" },
            ded_doc: { type: "string" },
            work_id: { type: "number", description: "工单id" },
            wcg_ded_transfer_type: {
              type: "string",
              description: "采购交易类型",
            },
            status: { type: "string", description: "抵扣状态" },
            referer: { type: "string", description: "商品来源" },
            pay_type: { type: "string", description: "交易类型" },
            admin_name: { type: "string", description: "操作人" },
            owner_admin_name: { type: "string", description: "订单负责人" },
            create_time: { type: "string", description: "待抵扣生成时间" },
            order_time: { type: "string", description: "订单生成时间" },
            use_ded_time: { type: "null", description: "使用抵扣时间" },
            dgm_name: { type: "string", description: "退换货负责人" },
            dg_group_name: { type: "string", description: "次品组" },
            supply_id: { type: "number", description: "供应商编号" },
            refunder: { type: "string", description: "退供员" },
          },
          required: [
            "wdid",
            "goods_img",
            "goods_name",
            "goods_no",
            "co_val",
            "si_val",
            "num",
            "market_name",
            "supply_name",
            "supply_city",
            "brand_name",
            "pg_name",
            "pgname",
            "woid",
            "ded_price",
            "price",
            "balance",
            "wcg_ded_status",
            "ded_doc",
            "work_id",
            "wcg_ded_transfer_type",
            "status",
            "referer",
            "pay_type",
            "admin_name",
            "owner_admin_name",
            "create_time",
            "order_time",
            "use_ded_time",
            "dgm_name",
            "dg_group_name",
            "supply_id",
            "refunder",
          ],
        },
      },
      count: { type: "number" },
      optionPicker: {
        type: "array",
        items: {
          type: "object",
          properties: { key: { type: "number" }, label: { type: "string" } },
          required: ["key", "label"],
        },
        description: "采购",
      },
      optionPurchase: {
        type: "array",
        items: {
          type: "object",
          properties: { key: { type: "number" }, label: { type: "string" } },
          required: ["key", "label"],
        },
        description: "买手",
      },
      optionReferer: {
        type: "array",
        items: {
          type: "object",
          properties: { key: { type: "number" }, label: { type: "string" } },
          required: ["key", "label"],
        },
        description: "商品来源",
      },
      optionStatus: {
        type: "array",
        items: {
          type: "object",
          properties: { key: { type: "number" }, label: { type: "string" } },
          required: ["key", "label"],
        },
        description: "抵扣状态",
      },
      optionPayType: {
        type: "array",
        items: {
          type: "object",
          properties: { key: { type: "number" }, label: { type: "string" } },
          required: ["key", "label"],
        },
        description: "交易类型",
      },
      owner_option: {
        type: "array",
        items: {
          type: "object",
          properties: { value: { type: "string" }, label: { type: "string" } },
          required: ["value", "label"],
        },
        description: "订单负责人",
      },
      dg_group: {
        type: "array",
        items: {
          type: "object",
          properties: { value: { type: "string" }, label: { type: "string" } },
          required: ["value", "label"],
        },
        description: "次品组",
      },
      option_dgm: {
        type: "array",
        items: {
          type: "object",
          properties: { value: { type: "string" }, label: { type: "string" } },
          required: ["value", "label"],
        },
        description: "退换货负责人",
      },
      dgm_refunder: {
        type: "array",
        items: {
          type: "object",
          properties: { value: { type: "string" }, label: { type: "string" } },
          required: ["value", "label"],
        },
        description: "退供人员",
      },
    },
  },
  requestFunctionName: "goodsDedList",
  extraInfo: {},
};
/**
 * 接口 [商品抵扣列表↗](http://yapi.yishou.com/project/128/interface/api/29938) 的 **请求函数**
 *
 * @分类 [采购商品↗](http://yapi.yishou.com/project/128/interface/api/cat_2286)
 * @请求头 `POST /erp/Deduction/goodsDedList`
 * @更新时间 `2021-10-08 15:45:07`
 */
export const goodsDedList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(goodsDedListRequestConfig, requestData), ...args);
};
goodsDedList.requestConfig = goodsDedListRequestConfig;
/**
 * 接口 [根据采购单\/账单获取活动商品↗](http://yapi.yishou.com/project/128/interface/api/33227) 的 **请求配置**
 *
 * @分类 [采购商品↗](http://yapi.yishou.com/project/128/interface/api/cat_2286)
 * @标签 `爆版4.22.0`
 * @请求头 `POST /erp/WcgOrder/listActivityGoodsByOrder`
 * @更新时间 `2022-03-14 17:10:48`
 */
const listActivityGoodsByOrderRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/WcgOrder/listActivityGoodsByOrder",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: "object",
    required: ["woid", "bill_id"],
    properties: {
      woid: { type: "string", description: "采购单id" },
      bill_id: { type: "string", description: "账单id" },
    },
  },
  responseDataJsonSchema: {
    type: "object",
    properties: {
      goods_list: {
        type: "array",
        items: {
          type: "object",
          properties: {
            activity_time: {
              type: "string",
              description: '"2010-01-22 23:44:50~2010-01-22 23:44:51"',
            },
            goods_name: { type: "string", description: '"商品名"' },
            goods_no: { type: "string", description: '"144456223"' },
            co_si: { type: "string", description: '"颜色/尺码"' },
            sku: { type: "string", description: '"2444123"' },
            activity_fee: { type: "string", description: '"22.0"' },
            num: { type: "string", description: '"2"' },
            order_id: { type: "string", description: '"5323"' },
            activity_id: { type: "string", description: '"98760"' },
            activity_type_text: { type: "string", description: '"活动类型"' },
            activity_name: { type: "string", description: '"活动名称"' },
            activity_fee_amount: { type: "string", description: '"44.00"' },
            goods_img: { type: "string", description: '"图片"' },
          },
          additionalProperties: false,
        },
        description:
          '[{"activity_time":"2010-01-22 23:44:50~2010-01-22 23:44:51","goods_name":"商品名","goods_no":"144456223","co_si":"颜色/尺码","sku":"2444123","activity_fee":"22.0","num":"2","order_id":"5323","activity_id":"98760","activity_type_text":"活动类型","activity_name":"活动名称","activity_fee_amount":"44.00","goods_img":"图片"}]',
      },
      activity_fee_amount: { type: "string", description: '"233.23"' },
      goods_kh_num: { type: "integer" },
      goods_num: { type: "integer" },
    },
    additionalProperties: false,
  },
  requestFunctionName: "listActivityGoodsByOrder",
  extraInfo: {},
};
/**
 * 接口 [根据采购单\/账单获取活动商品↗](http://yapi.yishou.com/project/128/interface/api/33227) 的 **请求函数**
 *
 * @分类 [采购商品↗](http://yapi.yishou.com/project/128/interface/api/cat_2286)
 * @标签 `爆版4.22.0`
 * @请求头 `POST /erp/WcgOrder/listActivityGoodsByOrder`
 * @更新时间 `2022-03-14 17:10:48`
 */
export const listActivityGoodsByOrder = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(listActivityGoodsByOrderRequestConfig, requestData),
    ...args,
  );
};
listActivityGoodsByOrder.requestConfig = listActivityGoodsByOrderRequestConfig;
/**
 * 接口 [获取采购订单详情数据↗](http://yapi.yishou.com/project/128/interface/api/33228) 的 **请求配置**
 *
 * @分类 [采购商品↗](http://yapi.yishou.com/project/128/interface/api/cat_2286)
 * @标签 `爆版4.22.0`
 * @请求头 `POST /erp/WcgOrder/getOrderInfo`
 * @更新时间 `2022-03-09 15:14:17`
 */
const getOrderInfoRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/WcgOrder/getOrderInfo",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: "object",
    required: ["woid"],
    properties: { woid: { type: "string", description: "采购单id" } },
  },
  responseDataJsonSchema: {
    type: "object",
    properties: {
      info: {
        type: "object",
        properties: {
          sumStyle: { type: "number" },
          sumPrice: { type: "string" },
          sumNum: { type: "number" },
          purchaseName: { type: "string" },
          new_goods_list: {
            type: "object",
            properties: {
              list: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    planid: { type: "string" },
                    goods_name: { type: "string" },
                    goods_no: { type: "string" },
                    co_val: { type: "string" },
                    si_val: { type: "string" },
                    num: { type: "string" },
                    price: { type: "string" },
                    woiid: { type: "string" },
                    ade_key: { type: "string" },
                    goods_type: { type: "string" },
                    wcg_plan_ptype: { type: "string" },
                    create_time: { type: "string" },
                    plan_price: { type: "string" },
                    dk_num: { type: "string" },
                    brand_name: { type: "string" },
                    main_img: { type: "string" },
                    middle_img: { type: "array", items: { type: "string" } },
                    activity_fee: { type: "number" },
                    service_fee: { type: "number" },
                    refund_service_fee: { type: "number" },
                    total: { type: "string" },
                    true_total: { type: "string" },
                  },
                },
              },
              total: {
                type: "object",
                properties: {
                  price: { type: "string" },
                  pay_price: { type: "string" },
                  total_num: { type: "string" },
                  refund_service_fee_rate: { type: "string" },
                  service_fee_rate: { type: "string" },
                  count: { type: "number" },
                },
              },
            },
          },
          ext: {
            type: "object",
            properties: {
              woid: { type: "string" },
              service_fee_rate: { type: "string" },
              refund_service_fee_rate: { type: "string" },
              service_fee: { type: "string" },
              refund_service_fee: { type: "string" },
              un_support_cat_ids: { type: "string" },
              refund_model: { type: "string" },
              sgp_id: { type: "string" },
              is_dispense: { type: "string" },
              ded_activity_fee: {
                type: "string",
                tag: "爆版4.22.0",
                description: "活动抵扣费用",
              },
            },
          },
          is_new: { type: "number" },
          woid: { type: "string" },
          wcg_order_pay_tool: { type: "string" },
          wcg_order_cg_type: { type: "string" },
          pay_tool: { type: "string" },
          source: { type: "string" },
          docs: { type: "array", items: { type: "string" } },
          pay_docs: { type: "string" },
          market_nikename: { type: "string" },
          supply_name: { type: "string" },
          note: { type: "string" },
          pgname: { type: "string" },
          status: { type: "string" },
          check_desc: { type: "string" },
          create_time: { type: "string" },
          pay_time: { type: "string" },
          create_price: { type: "string" },
          true_price: { type: "string" },
          pay_price: { type: "string" },
          ded_price: { type: "string" },
          diff_price: { type: "string" },
          order_price: { type: "string" },
          pay_account: { type: "string" },
          pay_contact: { type: "string" },
          pay_bank: { type: "string" },
          cnap_name: { type: "string" },
          cnap: { type: "string" },
          pay_remark: { type: "string" },
          pay_desc: { type: "string" },
          cg_type: { type: "string" },
          prepay_people: { type: "string" },
          dk_num: { type: "string" },
          dk_amount: { type: "string" },
          status_label: { type: "string" },
          bank_is_verify: { type: "number" },
          activity_price: { type: "string" },
          pay_fail_msg: { type: "string" },
          ded: {
            type: "object",
            properties: {
              sumPrice: { type: "string" },
              sumNum: { type: "number" },
            },
          },
          wdd_num: { type: "number" },
          all_ded: {
            type: "object",
            properties: {
              sumNum: { type: "number" },
              sumPrice: { type: "string" },
              list: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    woid: { type: "string" },
                    goods_name: { type: "string" },
                    goods_no: { type: "string" },
                    goods_kh: { type: "string" },
                    picker_group_code: { type: "string" },
                    brand_name: { type: "string" },
                    supply_name: { type: "string" },
                    referer: { type: "string" },
                    blp_note: { type: "string" },
                    blp_type: { type: "number" },
                    has_blp: { type: "number" },
                    has_fault_type: { type: "number" },
                    has_fault_typeStr: { type: "string" },
                    referer_str: { type: "string" },
                    create_time: { type: "string" },
                    price: { type: "string" },
                    woi_price: { type: "string" },
                    special_period: { type: "string" },
                    fault_param: {
                      type: "object",
                      properties: {
                        reject_id: { type: "string" },
                        blp_type: { type: "string" },
                        woiid: {
                          type: "array",
                          properties: {
                            "0": { type: "string" },
                            "2": { type: "string" },
                            "3": { type: "string" },
                            "4": { type: "string" },
                            "5": { type: "string" },
                            "6": { type: "string" },
                            "7": { type: "string" },
                            "11": { type: "string" },
                            "12": { type: "string" },
                            "13": { type: "string" },
                            "21": { type: "string" },
                            "40": { type: "string" },
                            "41": { type: "string" },
                          },
                          items: { type: "string" },
                        },
                        num: {
                          type: "object",
                          properties: {
                            "28612": { type: "number" },
                            "28782": { type: "number" },
                            "28784": { type: "number" },
                            "28792": { type: "number" },
                            "33886": { type: "number" },
                            "37154": { type: "number" },
                            "37156": { type: "number" },
                            "37192": { type: "number" },
                            "37207": { type: "number" },
                            "37208": { type: "number" },
                            "37209": { type: "number" },
                            "37282": { type: "number" },
                            "37314": { type: "number" },
                            "37632": { type: "number" },
                            "37683": { type: "number" },
                            "37684": { type: "number" },
                            "37685": { type: "number" },
                            "37686": { type: "number" },
                            "37812": { type: "number" },
                            "37829": { type: "number" },
                            "37830": { type: "number" },
                            "37833": { type: "number" },
                            "37834": { type: "number" },
                            "37836": { type: "number" },
                            "37837": { type: "number" },
                            "37838": { type: "number" },
                            "37839": { type: "number" },
                            "37842": { type: "number" },
                            "37843": { type: "number" },
                            "37844": { type: "number" },
                            "37845": { type: "number" },
                            "37846": { type: "number" },
                            "37847": { type: "number" },
                            "37848": { type: "number" },
                            "37849": { type: "number" },
                            "37852": { type: "number" },
                            "37853": { type: "number" },
                            "37976": { type: "number" },
                            "37978": { type: "number" },
                            "37980": { type: "number" },
                            "37981": { type: "number" },
                            "37985": { type: "number" },
                            "37987": { type: "number" },
                            "37988": { type: "number" },
                            "38073": { type: "number" },
                            "38074": { type: "number" },
                            "38091": { type: "number" },
                            "38095": { type: "number" },
                            "38127": { type: "number" },
                            "38783": { type: "number" },
                            "38797": { type: "number" },
                            "39304": { type: "number" },
                            "42705": { type: "number" },
                            "42706": { type: "number" },
                          },
                        },
                      },
                    },
                    num: { type: "number" },
                    sum_price: { type: "string" },
                    ded_price: { type: "string" },
                    has_periods: { type: "number" },
                    goods: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          img: { type: "string" },
                          si_val: { type: "string" },
                          co_val: { type: "string" },
                          num: { type: "number" },
                        },
                        required: ["img", "si_val", "co_val", "num"],
                      },
                    },
                    goodsDetail: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          woid: { type: "string" },
                          goods_name: { type: "string" },
                          goods_no: { type: "string" },
                          goods_img: { type: "string" },
                          imgs: { type: "array", items: { type: "string" } },
                          goods_kh: { type: "string" },
                          picker_group_code: { type: "string" },
                          brand_name: { type: "string" },
                          supply_name: { type: "string" },
                          referer: { type: "string" },
                          blp_type: { type: "number" },
                          blp_note: { type: "string" },
                          has_blp: { type: "number" },
                          referer_str: { type: "string" },
                          create_time: { type: "string" },
                          price: { type: "string" },
                          order_price: { type: "string" },
                          woi_price: { type: "string" },
                          colorCard: {
                            type: "array",
                            items: {
                              type: "object",
                              properties: {
                                co_id: { type: "string" },
                                co_val: { type: "string" },
                                img: { type: "string" },
                                card_thumb: { type: "string" },
                                item: {
                                  type: "array",
                                  items: {
                                    type: "object",
                                    properties: {
                                      si_val: { type: "string" },
                                      si_id: { type: "string" },
                                      stock: { type: "string" },
                                      sku: { type: "string" },
                                    },
                                    required: [
                                      "si_val",
                                      "si_id",
                                      "stock",
                                      "sku",
                                    ],
                                  },
                                },
                              },
                              required: [
                                "co_id",
                                "co_val",
                                "img",
                                "card_thumb",
                                "item",
                              ],
                            },
                          },
                          has_fault_type: { type: "number" },
                          has_fault_typeStr: { type: "string" },
                          fault_param: {
                            type: "object",
                            properties: {
                              reject_id: { type: "string" },
                              blp_type: { type: "string" },
                              woiid: {
                                type: "array",
                                items: { type: "string" },
                                properties: {
                                  "0": { type: "string" },
                                  "2": { type: "string" },
                                  "3": { type: "string" },
                                  "4": { type: "string" },
                                  "5": { type: "string" },
                                  "10": { type: "string" },
                                  "29": { type: "string" },
                                  "30": { type: "string" },
                                },
                              },
                              num: {
                                type: "object",
                                properties: {
                                  "28612": { type: "number" },
                                  "28782": { type: "number" },
                                  "28784": { type: "number" },
                                  "28792": { type: "number" },
                                  "33886": { type: "number" },
                                  "37154": { type: "number" },
                                  "37156": { type: "number" },
                                  "37192": { type: "number" },
                                  "37207": { type: "number" },
                                  "37208": { type: "number" },
                                  "37209": { type: "number" },
                                  "37282": { type: "number" },
                                  "37314": { type: "number" },
                                  "37632": { type: "number" },
                                  "37683": { type: "number" },
                                  "37684": { type: "number" },
                                  "37685": { type: "number" },
                                  "37686": { type: "number" },
                                  "37812": { type: "number" },
                                  "37829": { type: "number" },
                                  "37830": { type: "number" },
                                  "37833": { type: "number" },
                                  "37834": { type: "number" },
                                  "37836": { type: "number" },
                                  "37837": { type: "number" },
                                  "37838": { type: "number" },
                                  "37839": { type: "number" },
                                  "37842": { type: "number" },
                                  "37843": { type: "number" },
                                  "37844": { type: "number" },
                                  "37845": { type: "number" },
                                  "37846": { type: "number" },
                                  "37847": { type: "number" },
                                  "37848": { type: "number" },
                                  "37849": { type: "number" },
                                  "37852": { type: "number" },
                                  "37853": { type: "number" },
                                  "37976": { type: "number" },
                                  "37978": { type: "number" },
                                  "37980": { type: "number" },
                                  "37981": { type: "number" },
                                  "37985": { type: "number" },
                                  "37987": { type: "number" },
                                  "37988": { type: "number" },
                                  "38073": { type: "number" },
                                  "38074": { type: "number" },
                                  "38091": { type: "number" },
                                  "38095": { type: "number" },
                                  "38127": { type: "number" },
                                  "38783": { type: "number" },
                                  "38797": { type: "number" },
                                  "39304": { type: "number" },
                                  "42705": { type: "number" },
                                  "42706": { type: "number" },
                                },
                              },
                            },
                          },
                          num: { type: "number" },
                          ded_price: { type: "string" },
                          sum_price: { type: "string" },
                          reject_num: { type: "number" },
                          extra: {
                            type: "array",
                            items: {
                              type: "object",
                              properties: {
                                si_val: { type: "string" },
                                co_val: { type: "string" },
                                img: { type: "string" },
                                num: { type: "number" },
                              },
                              required: ["si_val", "co_val", "img", "num"],
                            },
                          },
                          greatData: { type: "number" },
                          detail: {
                            type: "array",
                            items: {
                              type: "object",
                              properties: {
                                id: { type: "string" },
                                key: { type: "string" },
                                reject_id: { type: "string" },
                                woiid: { type: "string" },
                                img: { type: "string" },
                                si_val: { type: "string" },
                                co_val: { type: "string" },
                                price: { type: "string" },
                                woi_price: { type: "string" },
                                sum_price: { type: "string" },
                                ded_price: { type: "string" },
                                num: { type: "number" },
                              },
                              required: [
                                "id",
                                "key",
                                "reject_id",
                                "woiid",
                                "img",
                                "si_val",
                                "co_val",
                                "price",
                                "woi_price",
                                "sum_price",
                                "ded_price",
                                "num",
                              ],
                            },
                          },
                        },
                        required: [
                          "woid",
                          "goods_name",
                          "goods_no",
                          "goods_img",
                          "imgs",
                          "goods_kh",
                          "picker_group_code",
                          "brand_name",
                          "supply_name",
                          "referer",
                          "blp_type",
                          "blp_note",
                          "has_blp",
                          "referer_str",
                          "create_time",
                          "price",
                          "order_price",
                          "woi_price",
                          "colorCard",
                          "has_fault_type",
                          "has_fault_typeStr",
                          "fault_param",
                          "num",
                          "ded_price",
                          "sum_price",
                          "reject_num",
                          "extra",
                          "greatData",
                          "detail",
                        ],
                      },
                    },
                    extra: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          si_val: { type: "string" },
                          co_val: { type: "string" },
                          img: { type: "string" },
                          num: { type: "number" },
                        },
                        required: ["si_val", "co_val", "img", "num"],
                      },
                    },
                    reject_num: { type: "number" },
                    colorCard: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          co_id: { type: "string" },
                          co_val: { type: "string" },
                          img: { type: "string" },
                          card_thumb: { type: "string" },
                          item: {
                            type: "array",
                            items: {
                              type: "object",
                              properties: {
                                si_val: { type: "string" },
                                si_id: { type: "string" },
                                stock: { type: "string" },
                                sku: { type: "string" },
                              },
                              required: ["si_val", "si_id", "stock", "sku"],
                            },
                          },
                        },
                        required: [
                          "co_id",
                          "co_val",
                          "img",
                          "card_thumb",
                          "item",
                        ],
                      },
                    },
                    goods_img: { type: "string" },
                    imgs: { type: "array", items: { type: "string" } },
                    items: {
                      type: "array",
                      items: {
                        type: "object",
                        properties: {
                          wdid: { type: "string" },
                          woid: { type: "string" },
                          woiid: { type: "string" },
                          reject_id: { type: "string" },
                          goods_no: { type: "string" },
                          ded_doc: { type: "string" },
                          img: { type: "string" },
                          si_val: { type: "string" },
                          co_val: { type: "string" },
                          num: { type: "string" },
                          price: { type: "string" },
                          ded_price: { type: "string" },
                          unded_price: { type: "string" },
                          woi_price: { type: "string" },
                          create_admin: { type: "string" },
                          create_time: { type: "string" },
                        },
                        required: [
                          "wdid",
                          "woid",
                          "woiid",
                          "reject_id",
                          "goods_no",
                          "ded_doc",
                          "img",
                          "si_val",
                          "co_val",
                          "num",
                          "price",
                          "ded_price",
                          "unded_price",
                          "woi_price",
                          "create_admin",
                          "create_time",
                        ],
                      },
                    },
                  },
                  required: [
                    "woid",
                    "goods_name",
                    "goods_no",
                    "goods_kh",
                    "picker_group_code",
                    "brand_name",
                    "supply_name",
                    "referer",
                    "blp_note",
                    "blp_type",
                    "has_blp",
                    "has_fault_type",
                    "has_fault_typeStr",
                    "referer_str",
                    "create_time",
                    "price",
                    "woi_price",
                    "special_period",
                    "fault_param",
                    "num",
                    "sum_price",
                    "ded_price",
                    "has_periods",
                    "goods",
                    "goodsDetail",
                    "extra",
                    "reject_num",
                    "colorCard",
                    "goods_img",
                    "imgs",
                    "items",
                  ],
                },
              },
            },
          },
          all_ded_num: { type: "number" },
          all_ded_price: { type: "string" },
          goodsList: {
            type: "array",
            items: {
              type: "object",
              properties: {
                goods_no: { type: "string" },
                goods_name: { type: "string" },
                goods_kh: { type: "string" },
                pg_name: { type: "string" },
                brand_name: { type: "string" },
                price: { type: "string" },
                plan_price: { type: "string" },
                market_price: { type: "string" },
                special_period: { type: "string" },
                create_time: { type: "string" },
                num: { type: "string" },
                sum_price: { type: "string" },
                goods_img: { type: "string" },
                si_val: { type: "string" },
                si_id: { type: "string" },
                co_val: { type: "string" },
                co_id: { type: "string" },
                addedNum: { type: "string" },
                img: { type: "string" },
                woiid: { type: "string" },
                pay_num: { type: "number" },
              },
            },
          },
        },
      },
      activity_detail: {
        type: "object",
        properties: {
          sku_price: {
            type: "object",
            properties: { "1206500077-咖色-110-43811": { type: "string" } },
          },
          list: { type: "array", items: { type: "string" } },
        },
      },
      logs: {
        type: "array",
        items: {
          type: "object",
          properties: {
            action_admin: { type: "string" },
            action_type: { type: "string" },
            action_result: { type: "string" },
            create_time: { type: "string" },
            action_desc: { type: "string" },
            action_ext: { type: "string" },
          },
        },
      },
    },
  },
  requestFunctionName: "getOrderInfo",
  extraInfo: {},
};
/**
 * 接口 [获取采购订单详情数据↗](http://yapi.yishou.com/project/128/interface/api/33228) 的 **请求函数**
 *
 * @分类 [采购商品↗](http://yapi.yishou.com/project/128/interface/api/cat_2286)
 * @标签 `爆版4.22.0`
 * @请求头 `POST /erp/WcgOrder/getOrderInfo`
 * @更新时间 `2022-03-09 15:14:17`
 */
export const getOrderInfo = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(getOrderInfoRequestConfig, requestData), ...args);
};
getOrderInfo.requestConfig = getOrderInfoRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/controller/purchaseGoods.js